document.addEventListener("DOMContentLoaded", () => {
  const faqWrappers = document.querySelectorAll(".faq_content");

  faqWrappers.forEach((wrapper) => {
    const faqItems = wrapper.querySelectorAll(".faq_content_item");

    faqItems.forEach((item) => {
      const question = item.querySelector(".faq_content_que");
      const answer = item.querySelector(".faq_content_ans");

      if (!question || !answer) return;

      // Collapse all initially
      answer.style.height = "0px";

      question.addEventListener("click", () => {
        const isActive = question.classList.contains("active");

        // Close all inside this wrapper
        faqItems.forEach((otherItem) => {
          const otherQuestion = otherItem.querySelector(".faq_content_que");
          const otherAnswer = otherItem.querySelector(".faq_content_ans");
          if (!otherQuestion || !otherAnswer) return;

          otherQuestion.classList.remove("active");
          otherAnswer.style.height = "0px";
        });

        // Toggle current
        if (!isActive) {
          question.classList.add("active");
          answer.style.height = answer.scrollHeight + "px";
        }
      });
    });
  });
});